import React from "react";

import Effects from "./Effects";

const BridgeToEffect = () => {
  return (
    <>
      <Effects />
    </>
  );
};

export default BridgeToEffect;
